
$(document).ready(function () {
  var tabs = $('.product-description-area .tabs');

  tabs.each(function () {
    var links = $(this).find('a');
    var active = links.first().addClass('active');
    var content = $(active.attr('href'));

    // Hide all content except the first
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });

    // Handle click events
     links.on('click', function (e) {
     e.stopImmediatePropagation();
      e.preventDefault();
      active.removeClass('active');
      content.hide();

      active = $(this);
      content = $($(this).attr('href'));

      active.addClass('active');
      content.show();
    });
  });



           /* product lead time */

    const targetElement = document.querySelector("#AddToCartForm-template--18402334015720__main > div:nth-child(5) > label > span");

if (targetElement) {
   $('.lead-time').css('display', 'block'); 
    // Function to check text and trigger alert
    const checkText = () => {
        const text = $(targetElement).text().trim();
        if (text === "Assembled") {
          
       
            $('.unassembled').css('display', 'none');
            $('.assembled').css('display', 'inline'); // Show if needed
        } else if (text === "Unassembled") {
       
            $('.assembled').css('display', 'none');
            $('.unassembled').css('display', 'inline'); // Show if needed
        } else {
     
            $('.lead-time').css('display', 'none'); // Hide lead-time if no match
        }
    };

        // Initial check
        checkText();

        // Set up a MutationObserver to monitor text changes
        const observer = new MutationObserver(() => {
            checkText();
        });

        // Start observing the target element for changes
        observer.observe(targetElement, { childList: true, characterData: true, subtree: true });
    }else{
              $('.lead-time').css('display', 'none'); // Hide lead-time if no match
    }
});

